import React, { type ComponentProps } from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

const PlatformNavigationLoader: LoadableType<{
	content?: React.ReactNode;
	hideGSN?: boolean;
	scrollTreeToCurrent?: () => void;
	onExpand?: () => void;
	onCollapse?: () => void;
	onPeekStart?: () => void;
	onPeekEnd?: (args: { trigger: 'mouse-leave' | 'side-nav-expand' }) => void;
	sideNavContentRef?: React.Ref<HTMLDivElement | null>;
	bottomElem?: React.ReactNode;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PlatformNavigation" */ './PlatformNavigationComponent.tsx'
			)
		).PlatformNavigationComponent,
});

export const PlatformNavigation = (props: PlatformNavigationProps): React.JSX.Element => (
	<PlatformNavigationLoader {...props} />
);

type PlatformNavigationProps = ComponentProps<typeof PlatformNavigationLoader>;
